// extracted by css-extract-rspack-plugin
export default {"toolbar":"toolbar-gIJODd","companyList":"companyList-XI5qGd"};